import mapFunction from './mapResources';

export default mapFunction('products', {
    isFetching: false,
    items: [] 
});
